<template>
  <div class="flex flex-col">
    <input v-model="search" @input="searchDoctors" style="width: 100%" class="p-2 relative bg-white rounded-sm border border-solid border-grey-lightest 
    text-base text-grey-darkest focus:border-blue" type="search" placeholder="Search doctors..">
    <div class="flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow" />
    <div v-if="doctorList.length === 0">
      <span class="text-sm flex justify-center my-4">No Doctors</span>
    </div>
    <div v-else class='flex flex-col overflow-y-auto' style="height: calc(100vh - 8.5rem);">
      <div v-for="(doctor, index) in doctorList" :key="index" @click="selectDoctor(doctor)" 
        :class="{doctorActive : (doctor.id === selectedDoctor)}" 
        class="flex flex-col h-12 pl-3 pr-3 justify-center pt-3 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight">
        <div class="flex flex-row mb-2 items-center">
          <div class="text-sm font-semibold self-center capitalize">{{doctor.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      doctorList: [],
      isLoading: false,
      selectedDoctor: null,
      search: ''
    }
  },
  created: function () {
  },
  mounted: function () {
    this.loadDoctors()
  },
  methods: {
    loadDoctors: function () {
      this.isLoading = true
      this.$http.get(window.API_URL + 'doctors/doctors_list')
      .then(response => {
        if (response.status === 200) {
          this.doctorList = response.body
          this.isLoading = false
        } else {
          this.isLoading = false
        }
      }, response => {
      })
    },
    searchDoctors: function () {
      let search = this.search
      if (search.length > 0) {
        this.doctorList = this.doctorList.filter(function (obj) {
          if (obj.email.includes(search) || obj.name.includes(search)) {
            return obj
          }
        })
      } else {
        this.loadDoctors()
      }
    },
    selectDoctor: function (doctor) {
      this.$emit('getDoctor', doctor)
    }
  }
}
</script>

<style>
.patientActive {
  background-color: #dae1e7
}

</style>


// WEBPACK FOOTER //
// src/components/Admin/DoctorsList.vue